import ReactDOM from 'react-dom';

import { ModalProps } from './modal.model';
import { ModalBase } from './modal-base';

export function Modal(props: ModalProps) {
  return ReactDOM.createPortal(<ModalBase {...props} />, document.body);
}
